import { Box, Button, Chip, Typography, styled } from '@material-ui/core';

export const LandingPageWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'flex-start',
}));

export const LandingMain = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  width: '100%',
}));

export const BannerContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  minHeight: 380,
  borderRadius: 14,
  overflow: 'hidden',
  backgroundImage: "url('/landing/dataCenter.jpg')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  padding: '80px 64px',
  color: theme.palette.common.white,
}));

export const BannerOverlay = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(90deg, #1456E0 7%, #1456E080 99%)',
}));

export const BannerContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  maxWidth: 660,
  color: theme.palette.common.white,
}));

export const BannerTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 800,
  fontSize: '44px',
  lineHeight: '52px',
  margin: 0,
  color: theme.palette.common.white,
}));

export const BannerSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Open Sans',
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: '28px',
  color: theme.palette.common.white,
}));

export const AuthButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  top: 24,
  right: 24,
  color: theme.palette.primary.main,
  fontWeight: 700,
  textTransform: 'uppercase',
}));

export const CardsGrid = styled(Box)(
  ({ gridLength }: { gridLength: number }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${gridLength}, minmax(260px, 1fr))`,
    gap: 16,
  }),
);

export const OptionCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 12,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
  minHeight: 320,
  cursor: 'pointer',
  outline: 'none',
}));

export const OptionMedia = styled(Box)(() => ({
  height: 240,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}));

export const OptionBody = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: '18px 16px 20px',
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.common.white,
  height: '100%',
}));

export const OptionTitle = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '28px',
  margin: 0,
}));

export const OptionDescription = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.grey[300],
}));

export const CapabilitiesWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
}));

export const CapabilitiesGrid = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
}));

export const CapabilityChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.common.white,
  padding: '6px 12px',
  fontSize: 14,
  margin: 0,
}));

export const FunctionIcon = styled('img')(() => ({
  width: 20,
  height: 20,
  margin: 0,
}));

export const CardsColumn = styled(Box)(() => ({
  flex: 1.6,
  display: 'flex',
  flexDirection: 'column',
}));

export const CapabilityTitle = styled(Typography)(({ theme }) => ({
  fontSize: '34px',
  margin: 0,
  color: theme.palette.text.primary,
}));

export const CapabilitySubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Red Hat Display',
  fontWeight: 700,
  fontSize: '20px',
  color: theme.palette.text.secondary,
}));

export const RowSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  width: '100%',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
}));

export const PortalCapabilitiesWrapper = styled(Box)(() => ({
  flex: 1,
  minWidth: 280,
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  padding: '16px 8px',
}));
